import posed from "react-pose";

export const CrossFade = posed.span({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
});

export const HeightExpand = posed.div({
  expanded: { maxHeight: 100 },
  collapsed: { maxHeight: 0 }
});

export const SlideUp = posed.span({
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 350,
      ease: [0.3, 0, 0.45, 1] // eslint-disable-line no-magic-numbers
    }
  },
  exit: { y: 100, opacity: 0 }
});



// WEBPACK FOOTER //
// ./js/animations.js